"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPageUserInfoWidgetDataSchemaV2 = void 0;
var zod_1 = require("zod");
var MypageUserInfoSegmentBannerDataSchemaV2 = zod_1.z.object({
    button: zod_1.z.object({
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        }),
        title: zod_1.z.string(),
    }),
    imageUrl: zod_1.z.string(),
    subtitle: zod_1.z.string(),
    title: zod_1.z.string(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
var MypageUserInfoUserDataSchemaV2 = zod_1.z.object({
    nickname: zod_1.z.object({
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        }),
        title: zod_1.z.string(),
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
    }),
});
var MypageUserInfoMembershipBannerDataSchemaV2 = zod_1.z.object({
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    description: zod_1.z.string(),
    iconUrl: zod_1.z.string(),
    memberClassImageUrl: zod_1.z.string(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
var MypageUserInfoAssetItemDataSchemaV2 = zod_1.z.object({
    data: zod_1.z
        .object({
        action: zod_1.z
            .object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        })
            .nullable(),
        amount: zod_1.z.string().nullable(),
        replacementText: zod_1.z.string().nullable(),
        notice: zod_1.z.string().nullable(),
        tooltip: zod_1.z.string().nullable(),
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
    })
        .nullable(),
    retry: zod_1.z
        .object({
        api: zod_1.z
            .object({
            method: zod_1.z.string(),
            timeout: zod_1.z.number(),
            url: zod_1.z.string(),
        })
            .optional(),
        title: zod_1.z.string(),
    })
        .nullable(),
    status: zod_1.z.enum(['SUCCESS', 'FAIL']),
    title: zod_1.z.string(),
    type: zod_1.z.enum(['NOL_MONEY', 'NOL_COIN', 'NOL_POINT', 'COUPON']),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
var MypageUserInfoAssetDataSchema = zod_1.z.object({
    /** 놀머니, 놀포인트, 쿠폰 */
    items: zod_1.z.array(MypageUserInfoAssetItemDataSchemaV2),
    /** 놀코인 */
    coinDetails: zod_1.z.array(MypageUserInfoAssetItemDataSchemaV2),
});
var MypageUserInfoMemberTypeBannersDataSchema = zod_1.z.object({
    type: zod_1.z.enum(['CORPORATE', 'GOLD_SIGNUP', 'TOPING_SIGNUP', 'TOPING_INFO']),
    title: zod_1.z.string(),
    subtitle: zod_1.z.string().nullish(),
    imageUrl: zod_1.z.string(),
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
exports.MyPageUserInfoWidgetDataSchemaV2 = zod_1.z.object({
    /** 놀머니, 놀포인트, 쿠폰 등 자산 및 관련 링크의 정보 */
    asset: MypageUserInfoAssetDataSchema.nullable(),
    /** 세부 회원 유형 (가입) */
    memberTypeInfoBanners: zod_1.z.array(MypageUserInfoMemberTypeBannersDataSchema),
    /** 세부 회원 유형 (미가입) */
    memberTypeSignupBanners: zod_1.z.array(MypageUserInfoMemberTypeBannersDataSchema),
    /**
     * 회원등급에 따라 다르게 노출하는 띠배너 정보
     * 골드클래스 배너 정보
     */
    membershipBanner: MypageUserInfoMembershipBannerDataSchemaV2.nullable(),
    /**
     * 특정 집단(예, 비회원)에 노출되는 프로모션 용 배너
     * 비회원용 로그인 유도 위젯
     */
    segmentedBanner: MypageUserInfoSegmentBannerDataSchemaV2.nullable(),
    /**
     * 사용자 상세
     * 회원용 위젯 (비회원 - null)
     */
    user: MypageUserInfoUserDataSchemaV2.nullable(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
